import cloneDeep from 'lodash/cloneDeep'

// 支持分销的支付方式
const supportDistributionChannel = ['T-Wallet']

// 对于分销用户通道处理方法
export function handleDistributionData(data = []) {
  let channelList = cloneDeep(data)
  for (let i = 0; i < channelList.length; i++) {
    if (canReplacePrice(channelList[i])) {
      channelList[i].channelPrice = channelList[i].distributionPrice
    }
  }
  return channelList
}

// 支付方式支持分销 && distributionPrice存在 && discountRate存在
export function canReplacePrice(channel = {}) {
  return !!(
    supportDistributionChannel.includes(channel.payMethodName) &&
    channel.distributionPrice &&
    channel.discountRate
  )
}
